(function ($) {
    $.fn.arrowAjax = function (options = {}, config = {}) {
        const self = this;

        let ajaxConfig = Object.assign({},
            {
                onStart: function(){

                },
                beforeSend: function (xhr) {
                    $('#voyager-loader').show();
                },
                onDone: function (response) {
                    $('#voyager-loader').hide();
                    let message = (response.hasOwnProperty('message')
                        ? response.message : 'Successfully processed.');
                    // let desc = response.hasOwnProperty('desc') ? response.desc : "Thank You.";
                    let alertType = response.hasOwnProperty('alert-type') ? response['alert-type'] : 'success';
                    let alerter = toastr[alertType];
                    alerter(message);

                    if (response.hasOwnProperty('redirect')) {
                        window.location = response.redirect;
                        return true;
                    }
                    // window.location.reload();
                },
                onFail: function (error) {
                    $('#voyager-loader').hide();
                    if (typeof error.responseJSON.errors !== 'undefined') {
                        $.each(error.responseJSON.errors, function (key, value) {
                            if(Array.isArray(value)){
                                toastr.error(value[0]);
                            } else {
                                toastr.error(value);
                            }
                        });
                    } else if (typeof error.responseJSON.message !== 'undefined') {
                        toastr.error(error.responseJSON.message);
                    } else {
                        toastr.error(error.responseJSON);
                    }
                }
            }, config);

        let ajaxOptions = Object.assign({}, {
            type: self.attr('method') || "POST",
            url: self.attr('action') || '',
            data: self.serialize() || {},
        }, options);

        ajaxConfig.onStart();

        return new Promise(function (resolve, reject) {
            $.ajax(ajaxOptions).done(function (response) {
                if(config !== false) {
                    ajaxConfig.onDone(response);
                }
                resolve(response);
            }).fail(function (xhr) {
                if(config !== false) {
                    ajaxConfig.onFail(xhr);
                }
                reject(xhr);
            });
        });
    }
}(jQuery));
